// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_nC1gj","foot_link":"index_foot_link_p7Jpk","list":"index_list_tYlV7","link":"index_link_-LTQr","copyright":"index_copyright_1L8MK"};